import React from 'react'
import styled from 'styled-components'
import { useNavigate } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import { setActiveSection, setViewChurchFeedbackModal } from 'features/profileChurch/profileChurchSlice'
import {
    PCNavLi,
    PCNavLiTitle,
    PCNavLiTitleIcon, 
} from './extras.styled'
import { ICONS } from './navIcons'

import { getFeatureLabel, normalizeFeatureItem } from 'utils/churchFeatures'
import { useTranslation } from 'react-i18next'

export default function ChurchProfileNavMenu({items}) {
  const { t: translate } = useTranslation()

    const navigate = useNavigate()
    const dispatch = useDispatch()
    const { profileChurch, activeSection } = useSelector((state) => state.profileChurch)

    const handleClick = (value) => {

        if(value === 'feedback'){
            // open feedback modal
            dispatch(setViewChurchFeedbackModal(true))
            return
        }

        navigate(`/${profileChurch.username}?section=${value}`)
        dispatch(setActiveSection(value))
    }

    return (
        <MenuContainer>

            {
                <NavMenuTitleForMobile>
                    { profileChurch.fullName + translate("web:general.churchNavigation")}
                </NavMenuTitleForMobile>
            }

            {(items || []).map((item) => { 
                const normalizedItem = normalizeFeatureItem(item)
                if(normalizedItem?.enabled){
                    return (
                        <MenuItem 
                            key={normalizedItem.value}
                            onClick={() => handleClick(normalizedItem.value)}
                            >
                            <PCNavLiTitleIcon>
                                {ICONS[normalizedItem.value]}
                            </PCNavLiTitleIcon>    
                            <PCNavLiTitle> 
                                {getFeatureLabel(normalizedItem, translate)}
                            </PCNavLiTitle> 
                        </MenuItem>
                    )
                }
                return null
            })} 
        </MenuContainer>
    )
}

const NavMenuTitleForMobile = styled.div`

    display: none;

    @media (max-width: 768px) {
        display: flex;
        justify-content: flex-start;
        align-items: flex-start;
        color: var(--lightThemeFontColor);
        width: 100%;
        font-size: 18px; 
        margin-bottom: 10px;
    }

`

const MenuContainer = styled.div`
    position: absolute;
    top: 45px;
    /* border: 3px solid red; */
    right: 0px;
    background-color: #fff;
    width: fit-content;
    min-width: 220px;
    height: fit-content;
    z-index: 99;
    padding: 8px;
    border-radius: 15px;
    box-shadow: 0px 0px 10px #ccc;


    @media (max-width: 768px) {
        width: 90%;
        height: 80vh;
        top: 50px;
        right: 23px;
        padding: 11px 15px;
        display: flex;
        flex-direction: row;
        align-items: flex-start;
        justify-content: space-around;
        flex-wrap: wrap;
        overflow: auto;
        background-color: #eaeaea;

    }
`
const MenuItem = styled.div`
    z-index: 99;
    width: 100%;
    display: flex;
    align-items: center;
    padding: 8px 25px;
    cursor: pointer;
    font-size: 14px;
    border-radius: 10px;
    color: var(--lightThemeFontColor);
    &:hover {
        background-color: #eee; 
    }

    margin-bottom: 5px;
    
    @media (max-width: 768px) {
        padding: 10px 20px;
        width: 40%;
        flex-direction: column;
        align-items: center;
        justify-content: center;  
        background-color: white;
        border-radius: 10px;
        box-shadow: 0px 0px 10px #ccc;
    }

`

